import type React from 'react';

import { parseHtml } from '@change-corgi/core-react/html';

import { CtaButton } from './CtaButton';
import { C } from './styles';
import type { ActionAlertPreviewData } from './types';

export const DefaultContentBlock: React.FC<{ data: ActionAlertPreviewData }> = ({ data }) => {
	const showImage = data.imageUrl && data.imageUrl !== 'default';
	return (
		<>
			{showImage && (
				<div style={{ marginBottom: 16 }}>
					<img src={data.imageUrl} alt="Petition" style={{ width: '100%', borderRadius: 12, display: 'block' }} />
				</div>
			)}
			<h1 style={{ fontSize: 24, fontWeight: 700, margin: '0 0 16px', lineHeight: 1.3 }}>
				{data.petitionTitle ?? 'Petition Title'}
			</h1>
			<div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
				{data.creatorPhotoUrl ? (
					<img
						src={data.creatorPhotoUrl}
						alt={data.creatorName ?? 'Petition Creator'}
						style={{ width: 60, height: 60, borderRadius: '50%', objectFit: 'cover', flexShrink: 0 }}
					/>
				) : (
					<div style={{ width: 60, height: 60, borderRadius: '50%', backgroundColor: C.border, flexShrink: 0 }} />
				)}
				<p style={{ margin: 0, fontSize: 14, lineHeight: 1.4 }}>
					<strong>
						{data.signatureCount != null
							? `${new Intl.NumberFormat().format(data.signatureCount)} have signed ${data.creatorName ?? 'Petition Creator'}'s petition.`
							: `1,234 have signed ${data.creatorName ?? 'Petition Creator'}'s petition.`}
					</strong>
				</p>
			</div>
			<div style={{ height: 16, borderRadius: 100, backgroundColor: C.thermoBg, overflow: 'hidden', marginBottom: 16 }}>
				<div style={{ width: '50%', height: '100%', background: C.thermoFill, borderRadius: 100 }} />
			</div>
			<CtaButton
				type={data.ctaTypeTop}
				text={data.ctaTextTop}
				link={data.ctaLinkTop}
				style={data.ctaStyleTop}
				defaultText="Sign this petition"
			/>
			{data.description && (
				<div style={{ fontSize: 14, lineHeight: 1.6, margin: '12px 0' }}>{parseHtml(data.description)}</div>
			)}
			<CtaButton
				type={data.ctaTypeBottom}
				text={data.ctaTextBottom}
				link={data.ctaLinkBottom}
				style={data.ctaStyleBottom}
				defaultText="Sign this petition"
			/>
		</>
	);
};
